import { ConsignmentVendorApplicationContractPage } from "@/features/consignment-vendor-application/pages/ConsignmentVendorApplicationContractPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/vendor/consignment-vendor-application/contract",
)({
	component: ConsignmentVendorApplicationContractPage,
});
